"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssetMapAudioData = void 0;
var Application_1 = require("../Application");
var Audio_1 = require("../Audio");
var AssetMapData_1 = require("./AssetMapData");
/**
 * Stores audio specific data used to load and unload assets.
 */
var AssetMapAudioData = /** @class */ (function (_super) {
    __extends(AssetMapAudioData, _super);
    /**
     * @deprecated use Load/Assets/AudioAsset
     * @param pName
     * @param pAssetType
     * @param pCategory
     */
    function AssetMapAudioData(pName, pAssetType, pCategory) {
        var _this = _super.call(this, pName, pAssetType) || this;
        _this.category = pCategory;
        return _this;
    }
    AssetMapAudioData.prototype.isLoaded = function () {
        var track = Application_1.Application.instance.audio.getAudioTrack(this.assetName, this.category);
        if (track === undefined) {
            return false;
        }
        return track.getSource().state() !== Audio_1.HowlerUtils.State.UNLOADED;
    };
    return AssetMapAudioData;
}(AssetMapData_1.AssetMapData));
exports.AssetMapAudioData = AssetMapAudioData;
//# sourceMappingURL=AssetMapAudioData.js.map